/* eslint-disable */
// @ts-nocheck

import { rootHeaderNavigation } from '../roots';

type NavItem = HTMLLIElement & {
	[key: string]: unknown;
	index: number;
};

function _resizeNavBar() {
	const navbar = $('header > .nav-bar');
	const navmain = $('.nav-bar .nav-main');
	const navitems = navbar.find('.nav-main > li').not('.hidden-nav');
	const logo = navbar.find('a.account-logo');

	const hiddenNavRoot = navbar.find('.hidden-nav');
	const hiddenNav = navbar.find('.hidden-nav ul');

	const containerWidth = navbar.width() || 0;
	const logoWidth = logo.outerWidth(true) || 0;
	const ctaWidth = navbar.find('.cta-main-container').outerWidth(true) || 0;
	const dropdownWidth = hiddenNavRoot.outerWidth(true) || 0;

	let counted = false;
	let navWidth = 0;

	let actualWidth = containerWidth - logoWidth - ctaWidth - dropdownWidth;

	if (
		logo.css('position') === 'absolute' ||
		(logo.css('position') === 'relative' && logo.css('float') === 'none')
	) {
		actualWidth += logo?.outerWidth(true) || 0;
	}

	const navmainOuterWidth = navmain.outerWidth(true) || 0;
	const navmainWidth = navmain.width() || 0;

	// Consider navItems container padding / margin
	if (navmainOuterWidth - navmainWidth > 0) {
		actualWidth -= navmainOuterWidth - navmainWidth;
	}

	navmain.find('.hidden-nav > a').on('click', (e) => {
		e.preventDefault();
	});

	hiddenNav.show();

	// Add extra items to the dropdown
	for (let i = 0; i < navitems.length; i++) {
		(navitems[i] as NavItem).index = i;
		navWidth += $(navitems[i]).outerWidth(true) || 0;

		if (navWidth >= actualWidth) {
			hiddenNav.append($(navitems[i]));
		}
	}

	hiddenNav.find('li').each((index, item) => {
		if (counted === false) {
			navWidth += $(item).outerWidth(true) || 0;
			counted = true;
		}

		if (navWidth < actualWidth && (item as NavItem).index === navitems.length) {
			$(item).insertBefore(hiddenNav.parent());
			counted = false;
		}
	});

	if (hiddenNav.children().length) {
		hiddenNavRoot.show();
	} else {
		hiddenNavRoot.hide();
	}

	// Finally, remove the single item dropdown if the item fits the space
	if (hiddenNav.children().length === 1) {
		if (navWidth - dropdownWidth < actualWidth) {
			navmain.append(hiddenNav.children()[0]);
			hiddenNavRoot.hide();
		}
	}

	hiddenNav.css('display', '');
}

export function resizeNavBar() {
	_resizeNavBar();

	// To prevent flickering the div container, overflow was set to 'hidden' before mounting.
	const root = document.querySelector(rootHeaderNavigation);
	(root as HTMLDivElement).style.setProperty('overflow', 'unset');
}

$(() => {
	'use strict';

	$(window).on('resize', () => {
		_resizeNavBar();
	});
});
